const OVERRIDES = {
  75: "https://www.prefecturedepolice.interieur.gouv.fr",
  974: "https://www.reunion.gouv.fr",
  977: "https://www.saint-barth-saint-martin.gouv.fr",
  978: "https://www.saint-barth-saint-martin.gouv.fr",
};

export const prefectureSite = (dept) => {
  if (!dept) return null;
  if (OVERRIDES[dept.code]) return OVERRIDES[dept.code];
  const slug = dept.name
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/['’]/g, "")
    .replace(/\s+/g, "-");
  return `https://www.${slug}.gouv.fr`;
};
